// Plan ▸ Character study: the person chosen in the column, their study page's answers, where they appear, and who with.
export { StudyPage as component } from '../../views/story/StudyPage.tsx';
export { StoryColumn as column } from '../../views/story/StoryColumn.tsx';
export const room = 'plan';
export const page = 'study';
export const title = 'Character study';
export const help = 'character-studies';
export const columnTitle = 'People';
